// src/services/authContextRef.ts
import { AuthContextProps } from 'react-oidc-context';

// Create a mutable global reference that will hold the auth context
export const authContextRef: { current: AuthContextProps | null } = { current: null };

// Function to set the context (called once during provider setup)
export function setAuthContext(context: AuthContextProps): void {
  authContextRef.current = context;
}

// Export a getter to access the auth context from anywhere
export function getAuthContext(): AuthContextProps | null {
  return authContextRef.current;
}